import axios from 'axios'
import { UrlBase } from './config'

const notifications = {}

notifications.createNotification = (token, companyId, appId, { name, code }) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/notifications',
      data: { name, code }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

notifications.getNotification = (token, companyId, appId, id) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        id: id
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/notifications'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  })
}

notifications.getNotifications = (token, companyId, appId, pagination) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/notifications'
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  })
}

notifications.updateNotification = (token, companyId, appId, rolId, { name, code }) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/notifications/' + rolId,
      data: { name, code }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  })
}

export default notifications
